"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/require-default-props */
var react_1 = require("@fluentui/react");
var react_2 = __importStar(require("react"));
exports.CustomMessageBar = function (props) {
    var children = props.children, duration = props.duration, onDismiss = props.onDismiss;
    var _a = react_2.useState(false), visible = _a[0], setVisible = _a[1];
    var onDismissHide = function () {
        setVisible(false);
        if (onDismiss) {
            onDismiss();
        }
    };
    react_2.useEffect(function () {
        if (visible && duration) {
            setTimeout(function () {
                setVisible(false);
                if (onDismiss) {
                    onDismiss();
                }
            }, duration);
        }
    }, [visible, duration]);
    react_2.useEffect(function () {
        if (children) {
            setVisible(true);
        }
        else {
            setVisible(false);
        }
    }, [children]);
    return (react_2.default.createElement(react_2.default.Fragment, null, visible && (
    // eslint-disable-next-line react/jsx-props-no-spreading
    react_2.default.createElement(react_1.MessageBar, __assign({}, props, { onDismiss: onDismissHide }), children))));
};
exports.MessageBar = exports.CustomMessageBar;
//# sourceMappingURL=CustomMessageBar.js.map